import { gql } from '@apollo/client';

export const ChangePasswordMutation = gql`
    mutation ChangePassword($old: String!, $new: String!) {
        changePassword(old: $old, new: $new)
    }
`;
